import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import { GENERAL_INCOME_TYPE_ENDPOINT } from '../../config/endpoints';
import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_DELETE_CONFIG, DEFAULT_GET_CONFIG, DEFAULT_POST_CONFIG, DEFAULT_PUT_CONFIG } from '../../config/rest';
import {
  FLAG_GETTING_GENERAL_INCOME_TYPES,
  GET_GENERAL_INCOME_TYPES,
  CLEAR_GENERAL_INCOME_TYPES,
  FLAG_GETTING_GENERAL_INCOME_TYPE,
  GET_GENERAL_INCOME_TYPE,
  CLEAR_GENERAL_INCOME_TYPE,
} from '../types/accounting/GeneralIncomeType';
import { GENERAL_INCOME_TYPE_PATH } from '../../config/paths';

const flagGettingGeneralIncomeTypes = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_GENERAL_INCOME_TYPES,
    payload: flag,
  });

const getGeneralIncomeTypes = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingGeneralIncomeTypes(true));

    const query = tableFilters;

    const url = `${GENERAL_INCOME_TYPE_ENDPOINT}?${QueryString.stringify(
      query,
    )}`;

    const response = await fetch(url, { ...DEFAULT_GET_CONFIG });

    await isErrorResponse(response, null, dispatch);

    const types = await response.json();

    dispatch({ type: GET_GENERAL_INCOME_TYPES, payload: types });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingGeneralIncomeTypes(false));
  }
};

const clearGeneralIncomeTypes = () => (dispatch) =>
  dispatch({
    type: CLEAR_GENERAL_INCOME_TYPES,
  });

  const flagGettingGeneralIncomeType = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_GENERAL_INCOME_TYPE,
    payload: flag,
  });

const getGeneralIncomeType =
  async ({ generalIncomeTypeId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingGeneralIncomeType(true));
      const url = `${GENERAL_INCOME_TYPE_ENDPOINT}/${generalIncomeTypeId}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const generalIncomeType = await response.json();
      dispatch({
        type: GET_GENERAL_INCOME_TYPE,
        payload: generalIncomeType,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingGeneralIncomeType(false));
    }
  };

const clearGeneralIncomeType = () => (dispatch) =>
  dispatch({
    type: CLEAR_GENERAL_INCOME_TYPE,
  });

const postGeneralIncomeType =
  async ({ name, description, expenseCode, generalIncomeTypeLabel }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingGeneralIncomeType(true));
      const payload = {
        name, description, expenseCode, generalIncomeTypeLabel
      };
      const url = GENERAL_INCOME_TYPE_ENDPOINT;
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const generalIncomeType = await response.json();
      dispatch(push(`${GENERAL_INCOME_TYPE_PATH}/${generalIncomeType.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingGeneralIncomeType(false));
    }
  };

const putGeneralIncomeType =
  async (generalIncomeTypeId, { name, description, expenseCode, generalIncomeTypeLabel }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingGeneralIncomeType(true));
      const payload = {
        id: generalIncomeTypeId,
        name, description, expenseCode, generalIncomeTypeLabel
      };
      const url = `${GENERAL_INCOME_TYPE_ENDPOINT}/${generalIncomeTypeId}`;
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const generalIncomeType = await response.json();
      dispatch(push(`${GENERAL_INCOME_TYPE_PATH}/${generalIncomeType.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingGeneralIncomeType(false));
    }
  };

const deleteGeneralIncomeType =
  async ({ generalIncomeTypeId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingGeneralIncomeType(true));
      const url = `${GENERAL_INCOME_TYPE_ENDPOINT}/${generalIncomeTypeId}`;
      const response = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });
      await isErrorResponse(response, null, dispatch);
      await response;
      dispatch(push(GENERAL_INCOME_TYPE_PATH));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingGeneralIncomeType(false));
    }
  };

export {
  flagGettingGeneralIncomeTypes,
  getGeneralIncomeTypes,
  clearGeneralIncomeTypes,
  getGeneralIncomeType,
  putGeneralIncomeType,
  postGeneralIncomeType,
  deleteGeneralIncomeType,
  clearGeneralIncomeType
};
